const nodeSettings = {
    enableNotification: false,
    enableNotificationSound: false,
    width: {
        name: "Width",
        limit: [350, 700],
        value: 350
    },
    showTime: {
        label: "Enable table duration",
        value: true,
    },
    store: {
        label: "Enable store name",
        value: false,
    },
    served: {
        label: "Enable Served",
        value: false,
    },
    increaseScrollWidth: false,
    showScrollControls: true
}

export const pos_Settings_getters = {
    settings(state) {
        return (state.pos_settings) ? state.pos_settings : pos_settings
    },
    defaultSaleTypes() {
        return saleTypes
    },
    defaultServiceTypes() {
        return serviceTypes
    },
    statusTypes() {
        return statusTypes
    },
    itemStatusTypes() {
        return itemStatus
    },
    nodeSettings(state) {
        return state.pos_settings.nodeSettings
    },
    getPreferences(state) {
        return state.pos_settings.preferences
    },
    showStoreName(state) {
        let settings = state.pos_settings.nodeSettings;
        if (settings && settings.store) {
            return settings.store.value
        }
        return false;
    },
    showServed(state) {
        let settings = state.pos_settings.nodeSettings;
        if (settings && settings.served) {
            return settings.served.value
        }
        return false;
    }
}

export const pos_Settings_setters = {
    posSettings: (state, changeSet) => {
        //To avoid changing same object, we stringify and parse to remove reference
        state.pos_settings = changeSet ? JSON.parse(JSON.stringify(changeSet)) : pos_settings;
    },
    settings: (state, obj) => {
        state.pos_settings.nodeSettings = obj;
        localStorage.setItem('settings', JSON.stringify(obj));
    },
    resetSettings: (state) => {
        let settings = JSON.parse(JSON.stringify(nodeSettings));
        state.pos_settings.nodeSettings = settings;
        localStorage.removeItem('settings');
    },
    setPreferences: (state, obj) => {
        state.pos_settings.preferences = obj;
        localStorage.setItem('preferences', JSON.stringify(obj));
    },
    resetPreferences: (state) => {
        localStorage.removeItem('preferences');
        state.pos_settings.preferences = {
            serviceTypes: [],
            saleTypes: [],
            statusTypes: [],
            itemStatus: [1, 2],
            sortOrder: "1",
            checkSortOrder: "1",
            sortBy: "1",
        }
    }
}

const qsrForHere = {
    id: 1,
    displayName: "QSR",
    saleType: 1,
    icon: "flaticon-qsr",
    color: "red",
    enable: true
}

const takeAway = {
    id: 2,
    displayName: "Take Away",
    saleType: 1,
    icon: "flaticon-take-away",
    color: "green",
    enable: true
}

const dineIn = {
    id: 3,
    displayName: "Table",
    saleType: 1,
    icon: "flaticon-dining-table",
    color: "primary",
    enable: true
}

const delivery = {
    id: 4,
    displayName: "Delivery",
    saleType: 1,
    icon: "flaticon-delivery-scooter-1",
    color: "red",
    enable: true
}

const bar = {
    id: 5,
    displayName: "Bar",
    saleType: 1,
    icon: "flaticon-bar-service", //flaticon-fast-food
    color: "deep-orange",
    enable: true,
}

const serviceTypes = [qsrForHere, takeAway, dineIn, delivery, bar]
const saleTypes = [{
    id: 1,
    name: "Restaurant"
}, {
    id: 2,
    name: "Phone"
},
// {
//     id: 3,
//     name: "Web"
// }, {
//     id: 4,
//     name: "Aggregator"
// },
{
    id: 5,
    name: "Zomato"
},
{
    id: 6,
    name: "Swiggy"
}
]
const statusTypes = [{
    name: "Placed",
    color: "blue",
    status: 2
},
{
    name: "Accepted",
    color: "orange",
    status: 3
},
{
    name: "Done",
    color: "green darken-3",
    status: 4
},
// {
//     name: "REJECTED",
//     color: "red darken-4",
//     status: 8
// },
{
    name: "Void",
    color: "red",
    status: 9
}
]

const itemStatus = [{
    name: "Placed",
    color: "blue",
    status: 2
},
{
    name: "Accepted",
    color: "orange",
    status: 3
},
{
    name: "Done",
    color: "green darken-3",
    status: 4
},
{
    name: "Served",
    color: "#e91e63",
    status: 6
},
{
    name: "Void",
    color: "red",
    status: 9
},
]

const preferences = {
    serviceTypes: [],
    saleTypes: [],
    statusTypes: [],
    itemStatus: [2, 3],
    sortOrder: "1",
    checkSortOrder: "1",
    sortBy: "1",
}

export const pos_settings = {
    nodeSettings: localStorage.getItem('settings') ? JSON.parse(localStorage.getItem('settings')) : nodeSettings,
    preferences: localStorage.getItem('preferences') ? JSON.parse(localStorage.getItem('preferences')) : preferences,
}